import React from "react";
import { useFormContext } from "react-hook-form";
import Button from "./button";
import { observer } from "mobx-react-lite";

type SubmitButtonProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  text: string,
  disabled?: boolean
};

const SubmitButton = observer((props: SubmitButtonProps) => {
  const { formState: { isValid } } = useFormContext();

  const { text, disabled = false, color, ...rest } = props;

  React.useEffect(() => { return; }, []);

  const cssClasses = (disabled || !isValid)
    ? "disabled"
    : "next";

  //Note: required validation only applies on submit but if the button is disabled
  //you can click it & therefore the validation messages won't show
  //disabled={!isValid}

  return (
    <>
      <Button
        colour={color ?? ""}
        {...rest}
        className={`${cssClasses}`}
        type="submit"
        text={text} />
    </>
  );
});

export default SubmitButton;
